(function($) {

  const $buttons = $('.button-panel-button button');
  if( $buttons.length ) {

    $buttons.on('click', function(e) {
      let $this = $(this);
      let panelId = $this.attr('data-toggle-panel');
      let $panel = $(`[data-panel="${panelId}"]`);
      if( $panel.hasClass('active') ) {
        $('body').removeClass('menu-open no-scroll');
        $('html').removeClass('no-scroll');
        $panel.removeClass('active');
      } else {
        $('[data-panel]').removeClass('active');
        $('body').addClass('menu-open no-scroll');
        $('html').addClass('no-scroll');
        $panel.addClass('active');
      }
    });

    $('.button-panel-close').on('click', function(e) {
      let $panel = $(this).closest('.button-panel-panel');
      $panel.removeClass('active');
      $('body').removeClass('menu-open no-scroll');
      $('html').removeClass('no-scroll');
    });

  }

})(jQuery);